import { render, staticRenderFns } from "./ScoreStartList.vue?vue&type=template&id=2da30660&scoped=true&"
import script from "./ScoreStartList.vue?vue&type=script&lang=js&"
export * from "./ScoreStartList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStartList.vue?vue&type=style&index=0&id=2da30660&scoped=true&lang=css&"
import style1 from "./ScoreStartList.vue?vue&type=style&index=1&id=2da30660&scoped=true&lang=css&"
import style2 from "./ScoreStartList.vue?vue&type=style&index=2&id=2da30660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da30660",
  null
  
)

export default component.exports